<div *ngIf="noticias && noticias.length && loaded">

  <ion-card [ngStyle]="{'border': getBorder()}">
    <!-- <ion-slides autoplay="3000" pager="true">
      <ion-slide *ngFor="let n of noticias; " (click)="abrirDetalhes(n);">

        <background-image [hidden]="n.plaintext == '1'" class="image-heading-vazio" [src]="n.imagemApp | image:' '">
        </background-image>

        <background-image [hidden]="n.plaintext == '0'" class="image-heading" [src]="n.imagemApp | image:' '">
          <ion-row class="heading-row">
            <ion-col no-padding offset-100>
              <h2 [ngStyle]="{'font-size': getFontSize(), 'font-weight': getFontWeight(), 'color': getFontColor()}"
                text-capitalize class="main-title">{{n.titulo}}</h2>
              <h2 [ngStyle]="{'font-size': getFontSizeSub(), 'font-weight': getFontWeight(), 'color': getFontColor()}"
                text-capitalize class="resume">{{n.subtitulo}}</h2>
            </ion-col>
          </ion-row>
        </background-image>

      </ion-slide>
    </ion-slides> -->
  </ion-card>


</div>